module.exports = __webpack_public_path__ + "010ac46cb5e9953f61001df21c0b4743.png";